import { DataObject } from '@shared/models/data-object.model';
export enum TakeOffMarketActions {
  Create = 'create',
  Close = 'close',
  CreateSale = 'createSale',
  Link = 'link',
}
export enum reasoncode {
  deleted = 'Deleted',
  leased = 'Leased',
  renewed = 'Renewed',
  sold = 'Sold',
  saleLeaseBack = 'Sale-Leaseback',
}
export const DISPLAY_LINK_ON_CLOSED_STATUS = ['Leased', 'Renewed', 'Sold'];
export const SALE_CLOSED_STATUS = ['Sold', 'Sale-Leaseback'];
export const SALE_LEASE_STATUS = ['Leased', 'Sold', 'Sale-Leaseback'];
export function getFlagsBasedOnReasons(reason): DataObject {
  const resObj = {
    [reasoncode.deleted]: getDisableFlags(true, true, false),
    [reasoncode.leased]: getDisableFlags(false, true, false),
    [reasoncode.renewed]: getDisableFlags(false, true, false),
    [reasoncode.sold]: getDisableFlags(true, false, false),
    [reasoncode.saleLeaseBack]: getDisableFlags(false, false, false),
  };
  return resObj[reason];
}
export function getDisableFlags(leaseF, saleF, closeF) {
  return {
    createLeaseFlag: leaseF,
    createSaleFlag: saleF,
    closeFlag: closeF,
  };
}
